import { render, staticRenderFns } from "./DetailProyect.vue?vue&type=template&id=7078487a&scoped=true&"
import script from "./DetailProyect.vue?vue&type=script&lang=js&"
export * from "./DetailProyect.vue?vue&type=script&lang=js&"
import style0 from "./DetailProyect.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetailProyect.vue?vue&type=style&index=1&id=7078487a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7078487a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VChip,VIcon,VLayout,VSpacer})
